import { useCallback, useState } from 'react';
import { inDateRange } from '../utils/datetime';

export const useDateRange = ({ initialFrom = '', initialTo = '' } = {}) => {
  const [from, setFrom] = useState(initialFrom);
  const [to, setTo] = useState(initialTo);

  const invalid = Boolean(from && to && from > to);

  const filter = useCallback(
    (rows = [], field = 'created_at') =>
      invalid ? [] : rows.filter((row) => inDateRange(row?.[field], from, to)),
    [from, to, invalid]
  );

  return { from, to, setFrom, setTo, invalid, filter };
};

export default useDateRange;
